import { Component, Input } from '@angular/core';


@Component({
    selector: 'agpr-email-header',
    templateUrl: './email.header.component.html',
    styleUrls: ['./email.header.component.scss'],
    standalone: false
})
export class EmailHeaderComponent {
    @Input() subjectLine: string;
    @Input() previewText: string;
    @Input() fromName: string;
    @Input() replyEmail: string;
    @Input() sentDate: string;
}
